import { render } from "./ThePlatformSectionSolution.vue?vue&type=template&id=3b70259a&scoped=true"
import script from "./ThePlatformSectionSolution.vue?vue&type=script&lang=js"
export * from "./ThePlatformSectionSolution.vue?vue&type=script&lang=js"

import "./ThePlatformSectionSolution.vue?vue&type=style&index=0&id=3b70259a&lang=scss&scoped=true"

import exportComponent from "/Users/derem1991/workspace/newear/frontend/theearcasino/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b70259a"]])

export default __exports__